import { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";

import {
  Table,
  Icon,
  Alert,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  NotificationManager,
} from "design-react-kit";

import secureLocalStorage from "react-secure-storage";

import "../../assets/Table.css";
import TableSearch from "./TableSearch";
import TableHeader from "./TableHeader";
import { showFlowType } from "../../services/helpers";

const FlowsAITable = ({
  items,
  columns,
  openModalHandler,
  getReadyFlows,
  filterCodes,
}) => {
  const [results, setResults] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    setResults(items);
  }, [items]);

  const filterHandler = (e, items) => {
    const value = e.target.value;
    let filteredResults = "";
    if (value === "") {
      filteredResults = items;
    } else if (
      e.nativeEvent.inputType === "deleteContentBackward" ||
      e.nativeEvent.inputType === "deleteContentForward"
    ) {
      filteredResults = items.filter((item) => {
        return (
          item.flowName.toLowerCase().includes(value.toLowerCase()) ||
          item.clientCodeName.toLowerCase().includes(value.toLowerCase())
        );
      });
    } else {
      filteredResults = items.filter((item) => {
        return (
          item.flowName.toLowerCase().includes(value.toLowerCase()) ||
          item.clientCodeName.toLowerCase().includes(value.toLowerCase())
        );
      });
    }
    return filteredResults;
  };

  return (
    <Fragment>
      <div className="d-flex flex-column align-items-end justify-content-start">
        <div className="d-flex align-items-start justify-content-end w-100">
          <TableSearch
            items={items}
            filterHandler={filterHandler}
            setResults={setResults}
            text={"Cerca"}
          />
          <span title="Aggiornare i dati della tabella">
            <Icon
              icon="it-refresh"
              fill="#06c"
              className="ml-3 mt-1 mb-2"
              type="button"
              onClick={(e) => getReadyFlows(filterCodes)}
            />
          </span>
        </div>
        <Table responsive className="table">
          <TableHeader
            columns={columns}
            setResults={setResults}
            items={items}
          />
          <tbody>
            {results !== null &&
              results !== undefined &&
              results.map((result) => {
                return (
                  <tr key={result.id}>
                    <td className="predispositionDate">
                      {result.predispositionDate}
                    </td>
                    <td className="name">{result.flowName}</td>
                    <td className="clientName">{result.clientCodeName}</td>
                    <td className="clientCode text-center">
                      {result.clientCode}
                    </td>
                    <td className="flowType text-center">
                      {showFlowType(result.flowType)}
                    </td>
                    <td className="numberOfNotifications text-center">
                      {result.notificationNumber}
                    </td>
                    <td className="text-center flowsDropdown">
                      <UncontrolledDropdown className="table-dropdown">
                        <DropdownToggle>
                          <Icon icon="it-more-actions" fill="#06c" />
                          <Link to={null} className="moreActions">
                            Vedi azioni
                          </Link>
                        </DropdownToggle>
                        <DropdownMenu>
                          <div className="d-flex align-items-center ml-3">
                            <Icon icon="it-mail" fill="#06c" />
                            <Link
                              to={null}
                              className="trasmetti"
                              onClick={(e) => openModalHandler(result)}
                            >
                              Trasmetti
                            </Link>
                          </div>
                          <hr />
                          <div
                            className="d-flex align-items-center ml-3"
                            onClick={(e) => {
                              secureLocalStorage.setItem(
                                "flowName",
                                result.flowName
                              );
                              navigate(
                                `/notificheAI/flows/notifications/${result.id}`
                              );
                            }}
                          >
                            <Icon icon="it-password-visible" fill="#06c" />
                            <Link
                              to={null}
                              className="vediNotifiche"
                              onClick={(e) =>
                                navigate(
                                  `/notificheAI/flows/notifications/${result.id}`
                                )
                              }
                            >
                              Vedi notifiche
                            </Link>
                          </div>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </td>
                  </tr>
                );
              })}
            {results !== null && results.length === 0 && (
              <tr>
                <td colSpan={12}>
                  <Alert className="w-50 mx-auto" color="info">
                    Nessun risultato trovato!
                  </Alert>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <div>
        <NotificationManager
          containerId="table-user-message"
          fix="right"
          closeOnClick={true}
          state="success"
          duration={30000}
        />
      </div>
    </Fragment>
  );
};

export default FlowsAITable;
